// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","tag":"BuildTag-module__tag--dI","icon":"BuildTag-module__icon--tx","multiple":"BuildTag-module__multiple--GO","link":"BuildTag-module__link--BD"};